import Vue from 'vue'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    selectedLessons: []
  },
  mutations: {
    selectLesson(state, lesson) {
      state.selectedLessons.push(lesson)
    },
    deselectLesson(state, lesson) {
      let index = _.indexOf(state.selectedLessons, lesson)
      Vue.delete(state.selectedLessons, index)
    },
    deselectAllLesson(state) {
      state.selectedLessons = []
    }
  },
  actions: {
    async fetch({ dispatch }, type) {
      const url = `api/${type}s/lessons`
      const lessons = await this._vm.$axios.get(url)
      dispatch(
        'entities/lessons/insertOrUpdate',
        { data: lessons },
        { root: true }
      )
      return lessons
    }
  }
}
